@if (name === 'custom_period') {
  <div class="position-absolute datepicker" [ngClass]="isDatePickerOpen ? 'd-block' : 'd-none'">
    <div class="input-group">
      <input
        name="datepicker"
        class="form-control input-hidden"
        ngbDatepicker
        #datepicker="ngbDatepicker"
        [autoClose]="'outside'"
        (closed)="closeDatePicker()"
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="isMobile ? 1 : 2"
        [dayTemplate]="t"
        [minDate]="minDate!"
        [maxDate]="maxDate!"
        navigation="select"
        outsideDays="hidden"
        [startDate]="fromDate!"
        tabindex="-1"
        [footerTemplate]="footerTemplate"
        placement="bottom-end"
      />
      <ng-template #t let-date let-focused="focused">
        <span
          class="custom-day"
          [class.focused]="focused"
          [class.range]="isHovered(date) || isInside(date) || isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          [class.from]="fromDate && date.equals(fromDate) && (_toDate || (hoveredDate && hoveredDate.after(fromDate)))"
          [class.to]="_toDate && date.equals(_toDate)"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>
  <div class="input-group select-container">
    <span class="input-icon">
      <app-icam-icon iconName="calendar" [iconHeight]="'14px'" />
    </span>
    <input
      #dpFromDate
      class="form-select rounded-0 range-input fw-bold datepicker-input"
      [placeholder]="placeholder || ('FILTER.custom_period' | translate)"
      [value]="value || placeholder || ('FILTER.custom_period' | translate)"
      name="dpFromDate"
      (click)="triggerOpen(datepicker)"
      placement="bottom"
      [readonly]="true"
      [ngClass]="isLight ? 'light' : 'dark'"
      [disabled]="disabled"
    />
    @if (value) {
      <button type="button" class="btn-clear" (click)="clearDateSelection()" [disabled]="disabled">
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </div>
  <ng-template #footerTemplate>
    <div class="datepicker-footer">
      <button (click)="closeDatePicker()" [ngClass]="{ disabled: disabledBtn, light: isLight, dark: !isLight }">
        {{ 'FILTER.cancel' | translate }}
      </button>

      <button
        [ngClass]="{ disabled: disabledBtn, light: isLight, dark: !isLight }"
        (click)="closeDatePicker()"
        [disabled]="disabledBtn"
      >
        {{ 'FILTER.apply' | translate }}
      </button>
    </div>
  </ng-template>
} @else if (name === 'date') {
  <div class="position-absolute datepicker" [ngClass]="isDatePickerOpen ? 'd-block' : 'd-none'">
    <div class="input-group">
      <input
        name="datepicker"
        class="form-control input-hidden"
        ngbDatepicker
        #singleDatepicker="ngbDatepicker"
        [autoClose]="'outside'"
        (closed)="closeDatePicker()"
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="1"
        [dayTemplate]="singleDay"
        [minDate]="minDate!"
        [maxDate]="maxDate!"
        navigation="select"
        outsideDays="hidden"
        [footerTemplate]="footerTemplate"
        placement="bottom-end"
      />
      <ng-template #singleDay let-date let-focused="focused" let-selected="selected">
        <span
          class="custom-day"
          [class.focused]="focused && !selected"
          [class.selected]="selected"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>
  <div class="input-group select-container">
    <span class="input-icon">
      <app-icam-icon iconName="calendar" [iconHeight]="'14px'" />
    </span>
    <input
      #dateInput
      class="form-select datepicker-input rounded-0 fw-bold"
      [placeholder]="placeholder || ('FILTER.date' | translate)"
      [value]="value || placeholder || ('FILTER.date' | translate)"
      name="singleDate"
      (click)="triggerOpen(singleDatepicker)"
      placement="bottom"
      [readonly]="true"
      [ngClass]="isLight ? 'light' : 'dark'"
      [disabled]="disabled"
    />
    @if (value) {
      <button type="button" class="btn-clear" (click)="clearDateSelection()" [disabled]="disabled">
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </div>
}
